import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';

export const LinkRouter = (props) => <Link {...props} component={RouterLink} />;
